module.exports = __webpack_public_path__ + "static/media/Illus-Loyalty@2x.f47f0d98.png";